import { useDraggable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';

/**
 * Eén sleepbare kaart op het bord.
 *
 * De herkomst (`status`) reist mee in `data`, want bij het loslaten weet
 * dnd-kit alleen waar de kaart HEEN ging. Zonder die waarde is er geen 'van'
 * voor de statushistorie.
 *
 * @param {object} props
 * @param {string|number} props.id - Sleutel van het record
 * @param {string} props.status - De kolom waar de kaart nu in staat
 * @param {boolean} [props.disabled] - Slepen uit; de kaart blijft gewoon leesbaar
 * @param {React.ReactNode} props.children - De inhoud van de kaart
 * @returns {JSX.Element}
 */
const BoardCard = ({ id, status, disabled, children }) => {
    const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
        id,
        disabled,
        data: { status },
        // dnd-kit zet standaard `role: 'button'`. ARIA plat dan alles binnen de
        // kaart tot één naam, en de link naar het record — de enige navigatie
        // die de kaart heeft — bestaat niet meer voor een schermlezer. Zelfde
        // regel als #ui-heading-inside-button-stops-being-a-heading, dat een
        // link binnen een button expliciet noemt. `group` laat de inhoud staan.
        attributes: { role: 'group', roleDescription: 'versleepbaar' },
    });

    // `attributes` van dnd-kit brengt zelf `role="button"` en `aria-disabled`
    // mee, en spreidt als laatste — een eigen aria-disabled hierboven zou dus
    // toch overschreven worden.
    return (
        <div
            ref={setNodeRef}
            className={`board-card${isDragging ? ' board-card--dragging' : ''}${disabled ? ' board-card--locked' : ''}`}
            style={transform ? { transform: CSS.Translate.toString(transform) } : undefined}
            {...listeners}
            {...attributes}
            // Zonder bewerkrecht is de kaart geen bedieningselement, dus ook
            // geen tabstop die niets doet.
            tabIndex={disabled ? undefined : attributes.tabIndex}
        >
            {children}
        </div>
    );
};

export default BoardCard;
